/* eslint-disable camelcase */
import React from 'react';
import FAQSearch from 'views/common/components/Logical/Layout/Footer/NeedHelp/FAQSearch';
import TopFaqs from 'views/common/components/Logical/Layout/Footer/NeedHelp/TopFaqs';

const Footer = ({ faq_items, isContactUsPage }) => (
  <>
    <FAQSearch isContactUsPage={isContactUsPage && isContactUsPage} />
    <TopFaqs
      faq_items={faq_items}
      isContactUsPage={isContactUsPage && isContactUsPage}
    />
  </>
);

export default Footer;
